import { CategoriesEntity } from 'stores/categories/types';

export const tabs: CategoriesEntity[] = ['points-categories', 'product-categories'];
